// extracted by mini-css-extract-plugin
export default {"SendNotificationModalContainer":"SendContractRenovation_SendNotificationModalContainer__uQzVz"};